import { render, staticRenderFns } from "./redirectPage.vue?vue&type=template&id=1417ba75"
import script from "./redirectPage.vue?vue&type=script&lang=js"
export * from "./redirectPage.vue?vue&type=script&lang=js"
import style0 from "./redirectPage.vue?vue&type=style&index=0&id=1417ba75&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1417ba75')) {
      api.createRecord('1417ba75', component.options)
    } else {
      api.reload('1417ba75', component.options)
    }
    module.hot.accept("./redirectPage.vue?vue&type=template&id=1417ba75", function () {
      api.rerender('1417ba75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/jump_page/redirectPage.vue"
export default component.exports